import React from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea'
//mport { HiChevronDown, HiChevronDoubleUp } from "react-icons/hi";

const ServiceCard = ({ image, alt, text, onClick, isOpen }) => {

  return (
	 
	 <Card sx={{ width: 270, backgroundColor: '#e5e7eb', }} className='border-[2px] border-transparent hover:border-gray-600 transition-all duration-300 '>
		  <CardActionArea onClick={onClick} isOpen={isOpen} >
			<CardMedia
			  component="img"
			  className='h-[250px]'
			  image={image}
			  alt={alt}
			  title={alt}
			/>
			<CardContent sx={{p: 1,}}>
			  <Typography variant="body1" sx={{height: 90 }} className='text-center'>
			  	{text}
			  </Typography>
			</CardContent>
		  </CardActionArea>
		</Card>
	 
		
  )
}

export default ServiceCard
